import type React from "react";
import type * as type from "@vTypes";

import { type Dispatch, type SetStateAction } from "react";
import WeeklyOffTableHeader from "./WeeklyOffTableHeader";
import WeeklyOffTableRow from "./WeeklyOffTableRow";
import { ReactSortable } from "react-sortablejs";
import { images } from "@img/imagesMap";

interface WeeklyOffTableProps {
  WeeklyHolidayTableHeaderTitle: string;
  disabledColor?: boolean;

  list: type.FullNurseSchema[];
  setList: Dispatch<SetStateAction<type.FullNurseSchema[]>>;
  nurseCount: number;
  getAssignedDayForNurse?: (nurseId: string) => string | undefined;
  showDayColumn?: boolean;
  highlightedNurseId?: string | null;
  getPreceptorInfo?: (nurse: type.FullNurseSchema) => string;
  className?: string;
  selectedGroupId: string | null;
}

function WeeklyOffTable({
  nurseCount,
  WeeklyHolidayTableHeaderTitle,
  disabledColor,

  list,
  setList,
  getAssignedDayForNurse,
  showDayColumn = false,
  highlightedNurseId,
  getPreceptorInfo,
  className,
  selectedGroupId,
}: WeeklyOffTableProps) {
  const isTotalView = WeeklyHolidayTableHeaderTitle === "총 배치인원 주휴배치";

  return (
    <div className={className}>
      <div className="rounded-[10px] shadow-[2px_2px_6px_0_rgba(0,0,0,0.15)] border border-[#D6D6DE] font-pretendard">
        <>
          <WeeklyOffTableHeader
            title={WeeklyHolidayTableHeaderTitle}
            disabledColor={disabledColor}
            nurseCount={nurseCount}
            showDayColumn={showDayColumn}
          />
          <ReactSortable
            tag={"div"}
            // 행 전체를 잡아서 드래그 드롭 가능하도록 수정
            // handle=".comp_btn_dragHandler"
            animation={100}
            group="weekly-off-assignment"
            list={list.map((nurse) => ({
              ...nurse,
              id: nurse.nurse_id,
              chosen: false, // multiDrag를 위한 기본값
            }))}
            setList={(newList) => {
              // Sortable이 추가한 내부 속성들을 제거
              const cleanedList = newList.map((item: any) => {
                const { chosen, selected, filtered, ...cleanNurse } = item;
                return cleanNurse as type.FullNurseSchema;
              });
              setList(cleanedList);
            }}
            disabled={isTotalView} // 총 배치인원 탭에서는 드래그 비활성화
            // MultiDrag 설정
            multiDrag={true}
            selectedClass="selected-nurse"
            multiDragKey="CTRL"
            avoidImplicitDeselect={false}
          >
            {list.length > 0 ? (
              list.map((nurse, index) => (
                <WeeklyOffTableRow
                  key={nurse.nurse_id}
                  nurse={nurse}
                  index={index}
                  assignedDay={
                    isTotalView && getAssignedDayForNurse
                      ? getAssignedDayForNurse(nurse.nurse_id)
                      : undefined
                  }
                  isHighlighted={highlightedNurseId === nurse.nurse_id}
                  showDayColumn={showDayColumn}
                  getPreceptorInfo={getPreceptorInfo}
                  isTotalView={isTotalView}
                  selectedGroupId={selectedGroupId}
                />
              ))
            ) : (
              <div className="flex flex-col justify-center items-center pt-[20px]">
                <img
                  src={images.icon_plus}
                  alt=""
                  className=""
                  style={{ height: "2em" }}
                />
                <div className="text-center text-[#333333] rounded-tl-[10px] rounded-tr-[10px] pt-[10px] font-pretendard">
                  {/* <div className="comp_tr comp_tr--oneLine text-center  text-gray-500 rounded-tl-[10px] rounded-tr-[10px] py-[20px]"> */}
                  아래 미지정 리스트에서 배치할 인력을 선택(다중선택 가능)하여
                  드래그해주세요.
                </div>
                <div className="text-center text-[#333333] rounded-tl-[10px] rounded-tr-[10px] pb-[20px] pt-[10px] font-pretendard">
                  *배치를 취소할 경우 미지정 리스트로 다시 옮겨주세요.
                </div>
              </div>
            )}
          </ReactSortable>
        </>
      </div>
    </div>
  );
}

export default WeeklyOffTable;
